import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApproveAddIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 9.5C8.39782 9.5 8.77936 9.34196 9.06066 9.06066C9.34196 8.77936 9.5 8.39782 9.5 8C9.5 7.60218 9.34196 7.22064 9.06066 6.93934C8.77936 6.65804 8.39782 6.5 8 6.5C7.60218 6.5 7.22064 6.65804 6.93934 6.93934C6.65804 7.22064 6.5 7.60218 6.5 8C6.5 8.39782 6.65804 8.77936 6.93934 9.06066C7.22064 9.34196 7.60218 9.5 8 9.5Z",
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00151 3.00098C9.4581 3.00171 10.8781 3.45699 12.064 4.30273C13.2499 5.14848 14.1426 6.34282 14.6177 7.71973C14.7207 8.01911 14.6251 8.32167 14.5033 8.60528C14.4433 8.74505 14.2705 8.79483 14.1363 8.72323C13.2894 8.2714 12.2916 8.13917 11.3574 8.35051C11.174 8.392 10.9918 8.23908 10.9948 8.05108C11.0079 7.24763 10.6975 6.45497 10.1216 5.87891C9.55902 5.3163 8.79521 5 7.99956 5C7.20407 5.00012 6.44097 5.3164 5.87846 5.87891C5.31599 6.44149 4.99956 7.20445 4.99956 8C4.99956 8.79554 5.31599 9.5585 5.87846 10.1211C6.45472 10.6974 7.24769 11.0084 8.05158 10.9953C8.23958 10.9923 8.3925 11.1745 8.35078 11.3578C8.25024 11.7996 8.22555 12.2566 8.27704 12.7069C8.29429 12.8578 8.18431 12.9977 8.03241 12.9984C6.57162 13.0048 5.1288 12.5511 3.93315 11.6982C2.74713 10.8522 1.85438 9.65752 1.37944 8.28027C1.31635 8.09688 1.31733 7.89726 1.38042 7.71387C1.85681 6.33734 2.75035 5.14352 3.93706 4.29883C5.12383 3.45411 6.54481 3.00032 8.00151 3.00098Z",
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12.25 14.25V10.25" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.25 12.25L14.25 12.25" })
	]
});
export default SvgApproveAddIcon;
